export default "__VITE_ASSET__Co$kpgaF__"